import { cloneDeep } from 'lodash'
import { checkProps } from '../../props'

function mergeTableProps(table) {
  const { store } = table
  const {
    rowHeight,
    expandedRowKeys = [],
    width,
    height,
    defaultSort,
    estimatedRowHeight,
    columns
  } = table.$props

  checkProps(table.$props)
  store.initStoreStates({
    ...table.$props,
    rowHeight,
    expandedRowKeys: cloneDeep(expandedRowKeys),
    columns: cloneDeep(columns),
    isAutoResizer: (!width && !height),
    sortMap: {
      ...(defaultSort || {
        order: '',
        prop: ''
      })
    },
    maxWidth: width,
    estimatedRowHeight
  })
}

function updateTableBaseData(table) {
  const { store } = table
  store.flatColumns()
  store.updateColumns()
  store.updateTableData({
    isUpdateTableRenderData: false // 初始化不需要。updateVirtualRange会执行
  })
  store.updateVirtualRange()
  store.updateHelperLine()
}


export function initTableStore({ table }) {
  mergeTableProps(table)
  updateTableBaseData(table)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/config/index.js